// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
    en: {
      translation: {
        categories: {
            babyShower: 'BABY SHOWER',
            pubertyFunction: 'PUBERTY CEREMONY',
            Consecration: 'CONSECRATION',
            earPiercingCeremony: 'EAR PIERCING CEREMONY',
            tonsuringCeremony: 'POST WEDDING',
            houseWarmingCeremony: 'HOUSE WARMING CEREMONY',
            wedding: 'WEDDING',
            firstHolyCommunion: 'FIRST HOLY COMMUNION',
            birthday: 'BIRTHDAY CEREMONY',
            baptism: 'BAPTISM',
            kovilKodaiVila: 'KOVIL KODAI VIZHA',
            nameCeremonyFunction: 'NAMING CEREMONY',
            others : 'Others',
            
          },
        home: 'HOME',
        photoFrames:'PHOTO FRAMES',
        gallery: 'GALLERY',
        selectPhotos: 'LOGIN',
        matrimony: 'Matrimony',
        pricing: 'Pricing',
        products: 'Products',
        about: 'ABOUT',
        bookSlot: 'BOOK A SLOT NOW',
        welcomeText: 'Welcome to New Brindha Studio',
        galleryLinkText: 'Gallery',
        pricingLinkText: 'Pricing',
        productLinkText: "Products",
        aboutLinkText: 'About',
        bookSlotFormTitle: 'BOOK YOUR SLOT',
        photoFramesFormTitle: 'PHOTO FRAMES FORM',
        formLabels: {
          name: 'Name',
          phone: 'Phone',
          eventDate: 'Event Date',
          eventTime: 'Event Time',
          eventType: 'Event Type',
          selectEventType: 'Select Event Type',
          frameSize: 'Frame Size',
          phoneNumber: 'PhoneNumber',

        uploadPhotos: 'Upload Photos',
        selectFrame: 'Select a Frame',
        previewPhotos:'Preview Photos'
        },
        selectFrameSize: 'Select Frame Size',
        submitBtn: 'SUBMIT',
        submitting: 'Submitting...',
        error: 'An unexpected error occurred',
      },
    },
    ta: {
      translation: {
        categories: {
            babyShower: 'வளைகாப்பு',
            pubertyFunction: 'பூப்புனித நீராட்டுதல்',
            Consecration: 'ஆலய பிரதிஷ்டை',
            earPiercingCeremony: 'முடி எடுக்கும் விழா',
            tonsuringCeremony: 'தொடக்க நிகழ்ச்சி',
            houseWarmingCeremony: 'புதுமனை புகுவிழா.',
            wedding: 'திருமணம்',
            firstHolyCommunion: 'நற்கருணை',
            birthday: 'பிறந்த நாள்',
            baptism: 'ஞானஸ்தானம் ',
            kovilKodaiVila: 'கோவில் கொடை விழா',
            nameCeremonyFunction: 'பெயர் வைக்கும் விழா',
            others : 'மற்றவை',
          },
          photoFramesFormTitle: 'புகைப்படக் கட்டகம் முன்பதிவு',

        home: 'முகப்பு',
        gallery: 'கேலரி',
        selectPhotos: 'உள்நுழைவு',
        matrimony: 'திருமணத்திற்கான அமைப்பு',
        pricing: 'விலை',
        products: 'எங்கள் தயாரிப்புகள்',
        photoFrames:'புகைப்படக் கட்டகம்',

        about: 'பற்றி',
        bookSlot: 'இப்போது ஒரு ஸ்லாட் முன்பதிவு செய்க',
        welcomeText: 'New Brindha ஸ்டூடியோவில் வரவேற்கின்றேன்',
        galleryLinkText: 'கேலரி',
        pricingLinkText: 'விலை',
        aboutLinkText: 'பற்றி',
        productLinkText: 'எங்கள் தயாரிப்புகள்',
        bookSlotFormTitle: 'உங்கள் ஸ்லாட் முன்பதிவு செய்யவும்',
        formLabels: {
          name: 'பெயர்',
          phone: 'தொலைபேசி',
          eventDate: 'நிகழ்வு தேதி',
          eventTime: 'நிகழ்வு நேரம்',
          eventType: 'நிகழ்வு வகை',
          selectEventType: 'ஒரு நிகழ்வைத் தேர்ந்தெடுக்கவும்',
          phoneNumber: 'தொலைபேசி எண்',
          frameSize: 'புகைப்படக் கட்டகம் அளவு',
        uploadPhotos: 'புகைப்படங்களைப் பதிவேற்றவும்',
        selectFrame: 'ஒரு பீசா தேர்வு செய்யவும்',
        previewPhotos: "புகைப்பட முன்னோட்டம்"
        },
        selectFrameSize: ' கட்டகம் அளவைக் தேர்ந்தெடுக்கவும்',
        submitBtn: 'சமர்ப்பிக்கவும்',
        submitting: 'சமர்ப்பிக்கின்றேன்...',
        error: 'ஒரு எதிர்பாராத பிழை ஏற்பட்டது',
      },
    },
  };
  
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;